export var TravellerTypes;
(function (TravellerTypes) {
    TravellerTypes[TravellerTypes["PersonalDetails"] = 0] = "PersonalDetails";
    TravellerTypes[TravellerTypes["CompanionEmpty"] = 1] = "CompanionEmpty";
    TravellerTypes[TravellerTypes["CompanionFilled"] = 2] = "CompanionFilled";
})(TravellerTypes || (TravellerTypes = {}));
